import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './_friendGlobal.css'
import { FormattedMessage } from 'react-intl'
import Button from 'components/util/Button'
import Modal from 'components/util/Modal'

export default class FriendPending extends Component {
  static propTypes = {
    friendInfo: PropTypes.object,
    cancelFriendRequestAction: PropTypes.func,
  }

  state = {
    confirmCancelRequest: false,
  }

  handleInitiateFriendRequestCancel = () => {
    this.setState({
      confirmCancelRequest: true,
    })
  }

  handleCancelFriendRequestCancel = () => {
    this.setState({
      confirmCancelRequest: false,
    })
  }

  handleConfirmFriendRequestCancel = () => {
    const { friendInfo } = this.props
    this.props.cancelFriendRequestAction(friendInfo.id)

    this.setState({
      confirmCancelRequest: false,
    })
  }

  render () {
    const { friendInfo } = this.props

    const basicUserInfo = {
      displayName: friendInfo.display_name,
      id: friendInfo.id,
    }

    const profile = `/profile/${basicUserInfo.id}`
    const profileImage = `${profile}/picture?size=Medium`

    return (
      <div className={styles.friendContainer}>
        <div className={styles.friendInner}>
          <a href={profile}>
            <img className={styles.profileImage} src={profileImage} />
          </a>
          <div className={styles.friendName}>
            <a href={profile}>{basicUserInfo.displayName}</a>
          </div>
          <Button
            size='small'
            type='secondary'
            el='button'
            onClick={this.handleInitiateFriendRequestCancel}>
            <FormattedMessage
              id='friendrequest.cancel'
              defaultMessage='Cancel'
            />
          </Button>
        </div>
        <Modal isOpen={this.state.confirmCancelRequest}>
          <div className={styles.unfriendConfirmationModal}>
            <h3 className={styles.modalHeader}>
              <FormattedMessage id='friends.cancelfriendrequest.confirm' defaultMessage='Cancel Pending Request?' />
            </h3>
            <div className={styles.modalBody}>
              <Button
                size='small'
                type='action'
                el='button'
                onClick={this.handleConfirmFriendRequestCancel}
                className={styles.confirmButton}>
                <FormattedMessage
                  id='unfriend.confirm'
                  defaultMessage='OK'
                />
              </Button>
              <Button
                size='small'
                type='secondary'
                el='button'
                onClick={this.handleCancelFriendRequestCancel}>
                <FormattedMessage
                  id='friends.cancelfriendrequest.cancel'
                  defaultMessage='Cancel'
                />
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/friends/FriendPending.jsx